export const ALLOWED_FILE_TYPES = [
  'application/pdf',                                                    // PDF
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',      // XLSX
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PPTX
  'application/msword',                                                // DOC
  'application/vnd.ms-excel',                                         // XLS
  'application/vnd.ms-powerpoint',                                    // PPT
  'text/csv',                                                         // CSV
  'application/vnd.ms-excel.sheet.macroEnabled.12',                   // XLSM
];

export const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.docx', '.xlsx', '.pptx', '.doc', '.xls', '.ppt', '.csv', '.xlsm'];

export const SUPPORTED_PREVIEW_TYPES = ['.pdf', '.docx', '.pptx'];

export const getTypeColor = (type) => {
  const colors = {
    // Core Documents
    'Adoption Agreement': { bg: '#e3f2fd', text: '#1565c0' },
    'Plan Document': { bg: '#e8f5e9', text: '#2e7d32' },
    'Form 5500': { bg: '#fce4ec', text: '#c2185b' },
    'Summary Plan Description (SPD)': { bg: '#f3e5f5', text: '#6a1b9a' },
    'Plan Highlights': { bg: '#fff3e0', text: '#e65100' },
    'Plan Health Report': { bg: '#e8eaf6', text: '#3f51b5' },
    
    // Investment Related
    'Investment Policy Statement (IPS)': { bg: '#e0f2f1', text: '#00796b' },
    'Investment Performance Reports': { bg: '#f1f8e9', text: '#558b2f' },
    'Investment Monitoring Reports': { bg: '#e0f2f1', text: '#00796b' },
    'Investment Change Notices': { bg: '#e3f2fd', text: '#1565c0' },
    
    // Reports & Reviews
    'Annual Plan Review': { bg: '#e1f5fe', text: '#0277bd' },
    'Quarterly/Annual Performance Reports': { bg: '#e1f5fe', text: '#0277bd' },
    'Summary Annual Report (SAR)': { bg: '#ffebee', text: '#c62828' },
    'Benefit Statements': { bg: '#f3e5f5', text: '#6a1b9a' },
    
    // Compliance & Testing
    'Compliance Testing Results': { bg: '#e0f2f1', text: '#00796b' },
    'ACP Testing Results': { bg: '#e0f2f1', text: '#00796b' },
    'Testing & Coverage Results': { bg: '#e0f2f1', text: '#00796b' },
    'Plan Compliance Checklists': { bg: '#ede7f6', text: '#512da8' },
    
    // Governance
    'Board Resolutions Related to the Plan': { bg: '#e8eaf6', text: '#3f51b5' },
    'Board Resolutions': { bg: '#e8eaf6', text: '#3f51b5' }, // Short version
    'Plan Sponsor Meeting Minutes': { bg: '#fbe9e7', text: '#bf360c' },
    'Fiduciary Responsibility Documentation': { bg: '#f3e5f5', text: '#6a1b9a' },
    'Fiduciary Audit Checklist': { bg: '#ede7f6', text: '#512da8' },
    
    // Participant Related
    'Participant Fee Disclosure': { bg: '#fff8e1', text: '#f57c00' },
    'Participant Education Materials': { bg: '#e0f7fa', text: '#00838f' },
    'Participant Loan Records': { bg: '#f3e5f5', text: '#6a1b9a' },
    'Participant Notices (e.g., Safe Harbor, QDIA)': { bg: '#e1f5fe', text: '#0277bd' },
    'Participant Complaints & Resolutions': { bg: '#e8eaf6', text: '#3f51b5' },
    'Participant Termination Notices': { bg: '#fce4ec', text: '#c2185b' },
    
    // Financial & Fees
    'Fee Benchmarking Reports': { bg: '#e0f2f1', text: '#00796b' },
    'Vendor Fee Disclosures': { bg: '#fff8e1', text: '#f57c00' },
    'Expense Reimbursement Records': { bg: '#e0f7fa', text: '#00838f' },
    
    // Legal & Regulatory
    'DOL/IRS Correspondence': { bg: '#ffebee', text: '#c62828' },
    'IRS Determination Letter': { bg: '#fbe9e7', text: '#bf360c' },
    'Regulatory Filing Confirmations': { bg: '#f1f8e9', text: '#558b2f' },
    'ERISA Fidelity Bond Documentation': { bg: '#e8eaf6', text: '#3f51b5' },
    
    // Contributions & Distributions
    'Contribution Reports': { bg: '#f1f8e9', text: '#558b2f' },
    'Distribution Forms': { bg: '#e3f2fd', text: '#1565c0' },
    'Form 1099-R (Distributions)': { bg: '#fce4ec', text: '#c2185b' },
    'Hardship Withdrawal Requests': { bg: '#ffebee', text: '#c62828' },
    'Loan Request Forms': { bg: '#fff3e0', text: '#e65100' },
    'Rollover Acknowledgment Forms': { bg: '#fff3e0', text: '#e65100' },
    
    // Agreements & Notices
    'Service Agreements': { bg: '#fbe9e7', text: '#bf360c' },
    'Custodial Agreement': { bg: '#fff3e0', text: '#e65100' },
    'Trust Agreement': { bg: '#efebe9', text: '#5d4037' },
    'Safe Harbor Notices': { bg: '#e8eaf6', text: '#3f51b5' },
    'Eligible Employee Notification': { bg: '#f3e5f5', text: '#6a1b9a' },
    
    // Plan Changes
    'Plan Amendments': { bg: '#e1f5fe', text: '#0277bd' },
    'Plan Restatement Documents': { bg: '#e3f2fd', text: '#1565c0' },
    'Summary of Material Modifications (SMM)': { bg: '#f3e5f5', text: '#6a1b9a' },
    'Plan Design Documentation': { bg: '#e8f5e9', text: '#2e7d32' },
    
    // Other Documents
    'Census Data Reports': { bg: '#e0f7fa', text: '#00838f' },
    'Corrective Action Documentation': { bg: '#fce4ec', text: '#c2185b' },
    'Plan Audit Reports': { bg: '#e0f2f1', text: '#00796b' },
    'Plan Enrollment Kit': { bg: '#fff8e1', text: '#f57c00' },
    'Recordkeeper & TPA Correspondence': { bg: '#e0f7fa', text: '#00838f' },
    
    // Default
    default: { bg: '#f5f5f5', text: '#616161' }
  };
  
  // First try exact match
  if (colors[type]) {
    return colors[type];
  }
  
  // Then try to find a partial match for truncated values
  const typeKeys = Object.keys(colors);
  for (const key of typeKeys) {
    if (key.startsWith(type) || type.startsWith(key)) {
      return colors[key];
    }
  }
  
  // If no match found, generate a consistent color based on the type string
  const hash = type.split('').reduce((acc, char) => {
    acc = ((acc << 5) - acc) + char.charCodeAt(0);
    return acc & acc;
  }, 0);
  
  const hue = Math.abs(hash % 360);
  const backgrounds = [
    `hsl(${hue}, 70%, 95%)`,
    `hsl(${hue}, 65%, 94%)`,
    `hsl(${hue}, 60%, 93%)`,
  ];
  const textColors = [
    `hsl(${hue}, 70%, 35%)`,
    `hsl(${hue}, 65%, 30%)`,
    `hsl(${hue}, 60%, 25%)`,
  ];
  
  const index = Math.abs(hash % 3);
  return { bg: backgrounds[index], text: textColors[index] };
};